// extracted by mini-css-extract-plugin
module.exports = {"container":"e_rfb","sizeSmall":"e_sfb","on":"e_tfb","handle":"e_ufb","variantGrey":"e_vfb","variantPrimary":"e_wfb"};